import { render, staticRenderFns } from "./ContactTypes.view.vue?vue&type=template&id=6786e3cc&scoped=true"
import script from "./ContactTypes.view.vue?vue&type=script&lang=js"
export * from "./ContactTypes.view.vue?vue&type=script&lang=js"
import style0 from "./ContactTypes.view.vue?vue&type=style&index=0&id=6786e3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786e3cc",
  null
  
)

export default component.exports